/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\variable.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import { ADD_VARIABLE, REMOVE_VARIABLE } from '../actions/variable';
import { VariableWrapper } from '../../logic/variable_wrapper';
import lpApp from '../../app/lp_app';

export default function variableReducer(state = {}, action) {
  switch (action.type) {
    case ADD_VARIABLE: {
      const wrappedVariable = new VariableWrapper(lpApp.references.getVariable(action.id));
      return {
        ...state,
        id: wrappedVariable.id,
        type: wrappedVariable.type,
        helper: wrappedVariable.helper,
        label: wrappedVariable.label,
      };
    }
    case REMOVE_VARIABLE:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/variable.js